
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KatalogDilAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "Kutuphane/KatalogDil";
        super(baseUrl);
    }


    KatalogDil() {

        return this.get("");

    }

}
export default new KatalogDilAPI();
